/*
 * Get-discount.ts
 * Description: Includes the declaration
 * of the function for getting discount data
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Getting discount data
 *
 * @return {Object} Promise - response with discount data
 * @param {Number} id - id of the discount
 * @param {Number} slug - slug of the restaurant
 */
export function getDiscount(id: number, slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/discounts/' + id,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data.data.attributes);
        }).catch(() => {
            reject();
        });
    });
}
